module.exports = __webpack_public_path__ + "static/Infographi4_mobile-875d4dc31f8381b615f05e45f0308b98.png";